import moment from 'moment';
import 'moment/locale/it';

export const initialiazeMomentConfig = () => {
  moment.locale('it');
};
